import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";

const type = `@@ActionType/UPDATE@${__filename}`;

const awardTypeMap = {
    reward: {
        key: "reward",
        value: "奖励",
        group: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.REWARD.code,
    },
    punishment: {
        key: "punishment",
        value: "惩罚",
        group: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.PUNISHMENT.code,
    },
    complaint: {
        key: "complaint",
        value: "投诉",
        group: BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE.COMPLAINT.code,
    },
};

const initState = {
    awardTypeMap: null,
    groupEnabledFinding: true, // 查找字段组开启状况 隐藏tab
    initializing: true, // 初始化
    selectedAwardType: "reward", // 选中的tab
    selectedUnitIds: null,
    unitsMap: null,
    keyword: "", // 搜索关键字

    // 用于传给filter,防止filter重复请求
    items: [], // 字段
    groups: [], // 字段组
    dicts: {}, // 字段 options

    itemsGroupMap: [], // groupBy 字段组

    data: null, // 查找的数据
    tableLoading: false, // 表格加载

    filterData: null, // 过滤参数数据
    filterDisplay: null, // 过滤参数显示

    editModalVisible: false, // 编辑新增modal
    editData: null, // 编辑中的数据
    editLoading: false, // 编辑保存加载

    picturesModalVisible: false, // 图片预览
    pictures: [], // 图片

    editOptionModalVisible: false, // 编辑选型modal
    editOptionData: null, // 编辑的选项
    editOptionModalLoading: false, // confirmLoading
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    awardTypeMap,
};
export default viewModel;
